(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4ff2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4ff2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6paxh", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4a9d401516a30f48$export$6503ec6e8aabbaf; }, function (v) { return $4a9d401516a30f48$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4a9d401516a30f48$export$f7ad0328861e2f03; }, function (v) { return $4a9d401516a30f48$export$f7ad0328861e2f03 = v; });
var $4a9d401516a30f48$export$6503ec6e8aabbaf;
var $4a9d401516a30f48$export$f7ad0328861e2f03;
"use strict";
var $4a9d401516a30f48$var$mapping = new Map();
function $4a9d401516a30f48$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4a9d401516a30f48$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4a9d401516a30f48$var$resolve(id) {
    var resolved = $4a9d401516a30f48$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4a9d401516a30f48$export$6503ec6e8aabbaf = $4a9d401516a30f48$var$register;
$4a9d401516a30f48$export$f7ad0328861e2f03 = $4a9d401516a30f48$var$resolve;

});

parcelRegister("a2fbw", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $74e5deaee85b16cb$export$bdfd709ae4826697; }, function (v) { return $74e5deaee85b16cb$export$bdfd709ae4826697 = v; });
var $74e5deaee85b16cb$export$bdfd709ae4826697;
var $74e5deaee85b16cb$export$c9e73fbda7da57b6;
var $74e5deaee85b16cb$export$5a759dc7a1cfb72a;
"use strict";
var $74e5deaee85b16cb$var$bundleURL = {};
function $74e5deaee85b16cb$var$getBundleURLCached(id) {
    var value = $74e5deaee85b16cb$var$bundleURL[id];
    if (!value) {
        value = $74e5deaee85b16cb$var$getBundleURL();
        $74e5deaee85b16cb$var$bundleURL[id] = value;
    }
    return value;
}
function $74e5deaee85b16cb$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $74e5deaee85b16cb$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $74e5deaee85b16cb$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $74e5deaee85b16cb$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$74e5deaee85b16cb$export$bdfd709ae4826697 = $74e5deaee85b16cb$var$getBundleURLCached;
$74e5deaee85b16cb$export$c9e73fbda7da57b6 = $74e5deaee85b16cb$var$getBaseURL;
$74e5deaee85b16cb$export$5a759dc7a1cfb72a = $74e5deaee85b16cb$var$getOrigin;

});

var $1f77d696bbb3c00a$exports = {};


(parcelRequire("6paxh")).register((parcelRequire("a2fbw")).getBundleURL("3ju2Y"), JSON.parse('["3ju2Y","index.56703d5a.js","aZ9hz","about.c31d2fd5.js","8bWlx","home.6729a46c.js","bkNFS","header-brand.081bfa2c.js","jz4fT","page-footer.e469ead6.js","gDFNH","discharge-cover.0953b596.png","9aStT","discharge.data.c6098c8e.js","bFMvc","flood-extent-cover.0b0bf217.png","7eNaI","flood-extent-emsr861.data.500a478a.js","2ZXy2","flood-extent.data.4f4eb64d.js","1rhzH","ivt-cover.d437c436.png","8mkgK","ivt.data.357ce3bd.js","6an2v","mslp-cover.d437c436.png","iWkFs","mslp.data.290c4037.js","42YTQ","precipitation-cover.d437c436.png","bVJxV","precipitation.data.cd6306ce.js","7Fw6b","precondition-cover.d437c436.png","93Kt1","precondition.data.b714a950.js","eEFXt","soil-moisture-cover.413b7a89.png","1fI2S","soil-moisture.data.e6e348e8.js","a89UF","sst-cover.b2c25817.png","hcBpP","sst-anomaly.data.c6dfd5ac.js","alobs","hero-sentinel1-tejo.48ab182c.jpg","5LSU6","winter-2025-26-floods.stories.e69278f1.js","5je64","discharge-timeseries.275a5949.csv","9ukHO","a1-collapse-coimbra.4433a2f4.jpg","1hY7C","rainfall-anomaly.e28b8cf3.png","bIrNp","discharge-comparison-story.6e447a71.png","g7gtQ","gpm-precipitation-iberia-feb01-07.af96b6f5.jpg","aWbnG","mdx-content.822a12f4.js","de8v7","mdx-content.47b38ee8.js","jZWKB","xlsx.46531a5b.js","38OOw","mdx-content.c8f8f9b4.js","kVYyA","mdx-content.85ecafa3.js","j5A2g","mapbox-gl.d3b0bf4f.js","knWkk","marker-sdf.db41bce1.png","7NgPy","tour-comparison.b4c28c2d.gif","42o2K","tour-analysis.af1a1ea4.gif","8ctMF","mdx-content.15f37ff1.css","9QOIM","catalog-content.826d02df.js","ZZS2V","catalog-content.6f466256.css","5fM6z","catalog-content.37f47ba6.js","4JlxA","container.7c8b415b.js","73igl","mdx-content.ab947ede.js","6RBZ3","mdx-content.3bd840e0.js","llzuA","mdx-content.489ebcbb.js","71Vjw","mdx-content.2f8b6d44.css","fcGZd","mdx-content.55366b9f.css","3NACQ","mdx-content.f9e784a3.js","lL1zH","mdx-content.fc99bd7a.js","fjVg2","banner.aacdfeed.js","60e61","site-alert.6c3bcf48.js","hm6h1","cookie-consent.f0c4599b.js","kH0gO","cookie-consent.daefdb33.css","5Da7f","home.ce7a13b2.js","jMDF2","root-welcome--cover.eec7a022.jpg","khlyK","vp-01-illu.e16a91f2.png","8hYgz","vp-02-illu.23aae56a.png","frh22","vp-03-illu.2016f6ab.png","lNDzA","user-enthusiasts.d134e85d.jpg","wnwZF","user-scientists.0f1d1c3c.jpg","3TKSb","user-researcher.a227a485.jpg","6L4Ir","about.e4ef78f6.js","7923q","development.6b1e066a.js","iVGJT","container.0eb63a2c.js","iF8OO","container.33b6caac.js","dYtja","single.387f95d7.js","dNNIT","container.68f95d61.js","6hkdU","s-overview.4fa601c4.js","aKebQ","exploration.fc224a7a.js","7YFLv","sandbox.73b05e62.js","eXBR3","page.d9517936.js","asrW4","img-placeholder-5.6262760b.jpg","jkl9S","page.0f57bd3b.js","g55NO","chart.4669a60d.js","j7zg3","aq.4cb7c0a2.csv","e97bA","two-column.ac7a3449.csv","kBrOa","sample.57667550.json","hJExN","table.b669c9f2.js","as4UC","sandbox.e85c6042.css","cuXIz","user-pages.a87e78db.js","k4RTk","index.aad05afe.css"]'));

})();
//# sourceMappingURL=index.runtime.16cf861b.js.map
